
const analyticsActions = {
  session_started: 'session_started'
}

export default analyticsActions;